import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { WebRTCCallPage } from '../../pages/public/WebRTCCallPage'


export default function PublicCallNav() {
    return (
        <Routes>
            <Route path="/:slug/:id" element={<WebRTCCallPage />} />

        </Routes>
    )
}
